/*
 * clic-filter-buckets.js
 * ----------------------
 * Companion to bucketed filter values: the Head Shape numeric buckets in
 * snippets/filter.liquid (legacy path) and any `merge` group rendered by
 * snippets/clic-filter-group.liquid (CliC filter sets — string values too,
 * the members list is opaque to this script). E.g. the
 * Head Shape filter shows Narrow / Average / Wide instead of raw 1-5 values).
 *
 * Each <clic-filter-bucket> renders one visible checkbox (no `name`, so it
 * never serializes) plus hidden real checkboxes for its member values. When a
 * bucket is toggled, every bucket in the group recomputes the union of member
 * values across the checked buckets and syncs the hidden inputs to it — so a
 * value shared by two buckets (e.g. 2 in both Narrow and Average) stays
 * applied while either bucket remains checked. The filters form's debounced
 * `input` listener then submits as usual.
 */
(function () {
  'use strict';
  if (customElements.get('clic-filter-bucket')) return;

  customElements.define(
    'clic-filter-bucket',
    class ClicFilterBucket extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-bucket-toggle]');
        if (!this.toggle) return;
        this.onToggle = () => this.syncGroup();
        this.toggle.addEventListener('change', this.onToggle);
      }

      disconnectedCallback() {
        if (this.toggle && this.onToggle) {
          this.toggle.removeEventListener('change', this.onToggle);
        }
      }

      syncGroup() {
        const group = this.closest('ul');
        if (!group) return;

        const wanted = new Set();
        group.querySelectorAll('clic-filter-bucket').forEach((bucket) => {
          const toggle = bucket.querySelector('[data-bucket-toggle]');
          if (!toggle || !toggle.checked) return;
          (bucket.dataset.values || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean)
            .forEach((value) => wanted.add(value));
        });

        group.querySelectorAll('[data-bucket-members] input').forEach((input) => {
          input.checked = wanted.has(input.value);
        });

        // The native toggle interaction already fired a bubbling `input` event;
        // this re-dispatch guarantees the debounced form submit sees the synced
        // member state even if the toggle was changed programmatically.
        this.dispatchEvent(new Event('input', {bubbles: true}));
      }
    }
  );
})();
